import { Fragment, memo } from "react";
import CustomNode from "./components/CustomNode";
import SoftBox from "components/SoftBox";

function CustomComponentNode({ data, id, selected }) {
  let whatNode = data;
  whatNode.id = data?.id;

  const generateTooltip = (elem) => {
    const description = elem?.data?.description?.value || "";
    return (
      <Fragment>
        <SoftBox className="custom-node-tooltip">
          <p className="custom-node-tooltip-description"> {description}</p>
        </SoftBox>
      </Fragment>
    );
  };

  return <CustomNode data={data} id={id} selected={selected} generateTooltip={generateTooltip} />;
}
export default memo(CustomComponentNode);
